import { SHOW } from '@/utils'
import { Loader2 } from 'lucide-react'
import { ReactNode } from 'react'

export default function SpinnerLoader({ children, label }: { children?: ReactNode; label?: string }) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center text-primary">
      <Loader2 className="animate-spin" size={64} />
      {children}
      <p {...SHOW(!!label)} className=" text-[18px] font-medium capitalize mt-4">
        {label}
      </p>
    </div>
  )
}
